import React from "react";
import { Card } from "antd";
import { LucideAward } from "lucide-react";

const ShortHeaderComponent = (props) => {
  const {
    icon: Icon ,
    title,
    description,
  } = props;

  return (
    <Card className="card-border-s white-purple rounded-xl">
      <div className="flex items-center gap-3">
        <div className="p-2 flex items-center justify-center gradient emerald shadow-lg rounded-xl text-white">
            <Icon className="w-6 h-6" />
        </div>
          <div className="flex flex-col">
              <h4 className="text-[18px]">
                {title}
              </h4>
            <p className="text-[13px] text-gray-700">
              {description}
            </p>
        </div>
          </div>

    </Card>
  );
};

export default ShortHeaderComponent;
